var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconViewWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9763 19.0286C7.42359 19.0286 3.37039 16.2589 1.05993 11.9843C3.37044 7.71042 7.42368 4.94 11.9763 4.94C16.5289 4.94 20.5822 7.71043 22.8927 11.9843C20.5822 16.2589 16.529 19.0286 11.9763 19.0286Z",
    stroke: "white",
    strokeWidth: 1.88
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9824 14.9862C13.6359 14.9862 14.9764 13.6457 14.9764 11.9921C14.9764 10.3385 13.6359 8.99805 11.9824 8.99805C10.3288 8.99805 8.98828 10.3385 8.98828 11.9921C8.98828 13.6457 10.3288 14.9862 11.9824 14.9862Z",
    stroke: "white",
    strokeWidth: 1.88
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewWhite);
export default __webpack_public_path__ + "static/media/icon-view-white.34653bc3fbd393e4de046d1448b4cb1d.svg";
export { ForwardRef as ReactComponent };